import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_triangle_up",
  "use": "icon-arrow_triangle_up-usage",
  "viewBox": "0 0 8.6 6.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 8.6 6.5\" id=\"icon-arrow_triangle_up\">\n<polyline points=\"4.8,6.5 8.6,6.5 4.3,0 0,6.5 3.8,6.5 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol